<template>
    <div style="width: 100%;">
        <div class="catalogueArea">
            <ul class="oneUl">
                <li class="oneLi" v-for="(item,index) in chaplist" :key="index">
                    <div class="onelevelBox" @click="onelevelFoldHandle(item,index)">
                        <div class="onelevelBox_l">{{item.sctitle}}</div>
                        <div class="onelevelBox_r"><span>{{item.checked?'收起':'展开'}}</span><i class="iconfont icon-aaa" :class="{'rotateClass':item.checked}"></i></div>
                    </div>
                    <el-collapse-transition>
                        <ul class="twoUl" v-show="item.checked">
                            <li class="twoLi"  v-for="(item1,index1) in item.children" :key="index1" @click="toStudyPage(item1)">
                                <div class="twoLevelBox">
                                    <div class="twoLevelBox_l">
                                        <i v-if="item1.restype == 1" class="iconfont icon-shipin"></i>
                                        <i v-else-if="item1.restype == 2" class="iconfont icon-pdf11"></i>
                                        <i v-else-if="item1.restype == 3" class="iconfont icon-kaoshi"></i>
                                        <i v-else-if="item1.restype == 6" class="iconfont icon-jiangyi"></i>
                                        <i v-else-if="item1.restype == 7" class="iconfont icon-diannao1"></i>
                                        <span class="titleText">{{item1.resname}}</span>
                                        <span class="learning-duration" v-if="types == 'stu' || types == 'studyResult' ">·学习时长：{{item1.studytimes_format}}</span>
                                    </div>

                                    <div class="twoLevelBox_r" v-if="types == 'stu'">
                                        <div class="twoLevelBox_r_flex">
                                            <div class="try-tag" v-if="item1.is_try===1">试学</div>
                                            <div v-else></div>
                                            <div v-if="item1.study_status == 0" class="textBtn noPending"><i class="el-icon-lock"></i></div>
                                            <div v-else-if="item1.study_status == 1" class="textBtn noPending">未学习</div>
                                            <div v-else-if="item1.study_status == 2  && ( item1.restype == 2 || item1.restype == 3 || item1.restype == 7 ) " class="textBtn noPending">进行中</div>
                                            <div v-else-if="item1.study_status == 2  && ( item1.restype == 1 || item1.restype == 6 ) " class="textBtn noPending">{{item1.do_pre}}</div>
                                            <div v-else-if="item1.study_status == 3" class="textBtn finshed">已完成</div>
                                            <div v-else-if="item1.study_status == 4 && item1.restype == 7" class="textBtn finshed">待审核</div>
                                            <div v-else-if="item1.study_status == 4 && item1.restype != 7" class="textBtn finshed">待统计</div>
                                            <div v-else-if="item1.study_status == 5" class="textBtn ">已驳回</div>
                                        </div>
                                    </div>
                                    <div class="twoLevelBox_r" v-if="types == 'teach'">
                                        <div class="twoLevelBox_r_flex" style="width: 100px;">
                                            <div class="try-tag" v-if="item1.is_try===1">试学</div>
                                            <div v-else></div>
                                            <div class="textBtn noPending">查看详情</div>
                                        </div>
                                    </div>
                                    <!-- 查看学习详细 -->
                                    <div class="twoLevelBox_r" v-if="types == 'studyResult'">
                                        <div v-if="item1.study_status == 0" class="textBtn noPending">未学习</div>
                                        <div v-else-if="item1.study_status == 1" class="textBtn noPending">未学习</div>
                                        <div v-else-if="item1.study_status == 2  && ( item1.restype == 2 || item1.restype == 3 || item1.restype == 7 ) " class="textBtn noPending">进行中</div>
                                        <div v-else-if="item1.study_status == 2  && ( item1.restype == 1 || item1.restype == 6 ) " class="textBtn noPending">{{item1.do_pre}}</div>
                                        <div v-else-if="item1.study_status == 3" class="textBtn finshed">已完成</div>
                                        <div v-else-if="item1.study_status == 4 && item1.restype == 7" class="textBtn finshed">待审核</div>
                                        <div v-else-if="item1.study_status == 4 && item1.restype != 7" class="textBtn finshed">待统计</div>
                                        <div v-else-if="item1.study_status == 5" class="textBtn ">已驳回</div>
                                    </div>

                                </div>
                            </li>
                        </ul>
                    </el-collapse-transition>
                </li>
            </ul>
            <NoData v-if="chaplist.length<=0"  :className="'smallClass'" style="margin: 8vh 0;"></NoData>
        </div>
        <el-dialog :title="$t('view report')" width="70%" :visible.sync="dialogTaskReport" custom-class="" top="10.5vh" class="dialogcomPaddingtBox" v-if="dialogTaskReport" center append-to-body	>
             <taskReport :reportFlag="reportFlag"  :spaceid="params.spaceid" :subid="reportsubid" :sccid="reportsccid"
                         :isStudent="true" :cangodetail="subinfo.time_status === 1"
             ></taskReport>
         </el-dialog>
    </div>
</template>
<script>
import isMobile from '@/api/isMobile.js';
import taskReport from '@/page/Public/ClassManagement/Teachers/dialog/dialogTaskReport.vue';
import NoData from '@/components/NoData/noData.vue';
export default{
    props:{
        resData:{},
        params:{},
        isJoin:{
            type:Number,
        },
        types:{
            default:'stu'
        }
    },
    data(){
        return{
            chaplist:[],
            subinfo:{},
            reportFlag:false,
            reportsubid:"",
            reportsccid:"",
            dialogTaskReport:false,
            allFoldFlag:true,
        }
    },
    created(){
        this.initData()
    },
    components:{
        taskReport,NoData
    },
    methods:{
        initData(){

            var chap =  this.resData.chap;
            if(chap.length<=0) return;
            for (let i = 0; i < chap.length; i++) {
                for (let j = 0; j < chap[i]['children'].length; j++) {
                    if (chap[i]['children'][j].sccid === this.resData.need_sccid){
                        chap[i].checked = true;
                    }
                }
            }
            this.chaplist = chap;
            this.subinfo = this.resData.subinfo;
            this.$forceUpdate()

        },
        //单个展开收起
        onelevelFoldHandle(item,index){
            item.checked = !item.checked;
            this.$set(this.chaplist,index,item);
        },
        //全部展示收起
        allFoldHandle(){
            this.allFoldFlag = !this.allFoldFlag;
            for(var i = 0; i < this.chaplist.length; i++){
                this.chaplist[i].checked = this.allFoldFlag;
            }
            this.$emit('setAllFoldFlag',this.allFoldFlag)
            this.$forceUpdate();
        },
        //去學習詳細
        to_study(sccid){
            var chap =  this.resData.chap;
            if(chap.length<=0) return;
            for (let i = 0; i < chap.length; i++) {
                for (let j = 0; j < chap[i]['children'].length; j++) {
                    if (chap[i]['children'][j].sccid === sccid){
                        this.toStudyPage(chap[i]['children'][j])
                    }
                }
            }
        },
        //去学习详细
        toStudyPage(item){
            //老师预览...
            if(this.types == 'teach'){
                if (item.restype === 1){

                    this.$router.push({path:`/courseVideo/${this.params.spaceid}/${item.subid}/${item.sccid}/1`})

                }else if (item.restype === 2){

                    this.$router.push({path:`/coursePDF/${this.params.spaceid}/${item.subid}/${item.sccid}/1`})

                }else if (item.restype === 3){

                    this.$router.push({path:`/coursePaper/${this.params.spaceid}/${item.subid}/${item.sccid}/1`})

                }else if (item.restype === 6){

                    this.$router.push({path:`/courseHandouts/${this.params.spaceid}/${item.subid}/${item.sccid}/1`})

                }else if (item.restype === 7){
                    if(isMobile()){
                        this.$message({
                            message:this.$t('Mobile terminal is not supported, please go to PC terminal operation!'), type:'warning'
                        })
                        return
                    }
                    var _href = `/courseTask/${this.params.spaceid}/${item.subid}/${item.sccid}/1`
                    if(item.is_forever == 1){
                        const { href } = this.$router.resolve({_href});
                        window.open(href,'_blank');
                    }else{
                        this.$router.push({path:_href})
                    }
                }
                return
            }
            //查看学习详细
            if(this.types == 'studyResult'){
                if (item.study_status === 0 || item.study_status === 1|| item.study_status === 2 || item.study_status === 5){
                    this.$notify({title: this.$t('Prompt'), message: "学员未完成学习", type: 'warning', duration:2000});
                    return  false ;//不允许学习
                }

                if (item.restype == 7){
                    this.$router.push({path: `/taskReport/${item.resid}/${item.reportid}`})
                }else  {
                    this.$router.push({path:`/studyDetail/${this.params.spaceid}/${item.subid}/${item.sccid}/${this.params.uid}`})

                }
                return ;

            }
            if(this.isJoin == 2 &&  item.is_try != 1){
                this.$emit("goStudy")
                return
            }
            //学生进入学习...
            // time_status 1:有效  2：课程的学习时间未开始  3：当前课程已过期
            if (this.subinfo.time_status != 1){
                this.$notify({title: this.$t('Prompt'), message: this.subinfo.time_status_text, type: 'warning', duration:2000});
                return  false ;//不允许学习
            }
            //状态判断   0、禁止学习  1、未作答 2、进行中 3、已完成  4、待统计（待审核） 5、驳回重做 ,
            if (item.study_status === 0){

                return  false ;//不允许学习

            }
            else if (item.study_status === 1 || item.study_status === 2 || item.study_status === 3 || item.study_status === 4 || item.study_status === 5){
                if (item.restype === 1){

                    this.$router.push({path:`/courseVideo/${this.params.spaceid}/${item.subid}/${item.sccid}/0`})

                }else if (item.restype === 2){

                    this.$router.push({path:`/coursePDF/${this.params.spaceid}/${item.subid}/${item.sccid}/0`})

                }else if (item.restype === 3){

                    if ( item.study_status === 3 ){

                        this.$router.push({path:`/evaluationReport/${this.params.spaceid}/${item.subid}/${item.sccid}`})
                    }else if( item.study_status === 4 ){

                        return ;
                    }else{

                        this.$router.push({path:`/coursePaper/${this.params.spaceid}/${item.subid}/${item.sccid}/0`})
                    }

                }else if (item.restype === 6){

                    this.$router.push({path:`/courseHandouts/${this.params.spaceid}/${item.subid}/${item.sccid}/0`})

                }else if (item.restype === 7){
                    if ( item.study_status === 3 || item.study_status === 4  ){

                        this.checkReportHandle(item)

                    }else{

                        if(isMobile()){
                            this.$message({
                                message:this.$t('Mobile terminal is not supported, please go to PC terminal operation!'), type:'warning'
                            })
                            return
                        }
                        var _href = `/courseTask/${this.params.spaceid}/${item.subid}/${item.sccid}/0`
                        if(item.is_forever == 1){
                            const { href } = this.$router.resolve({_href});
                            window.open(href,'_blank');
                        }else{
                            this.$router.push({path:_href})
                        }

                    }

                }
            }
            return true;

        },
        //实验报告弹窗
        checkReportHandle(item){
            if (item.reportstatus == 1) this.reportFlag = true;
            else if (item.reportstatus == 3) this.reportFlag = false;
            else if (item.reportstatus == 4) this.reportFlag = false;
            else return;
            this.dialogTaskReport = true;
            this.reportsccid = item.sccid;
            this.reportsubid = item.subid;
        },
    },
    watch:{
        'resData':{
            handler(newVal, oldVal){
                this.initData();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/assets/css/homepage/coursePack/catalogueList.scss";
</style>



// WEBPACK FOOTER //
// src/page/Public/CoursePack/catalogueList.vue